<template>
    <div>
        <div class="home">
            <div class="banner">
                <div class="banner_l">
                    <div class="banner_l_main">
                        <h3>{{ $t('aboutus') }}</h3>
                        <p>{{ $store.state.baseConfig.baseConfigInfo.aboutUs }}</p>
                        <div class="banner_l_text">
                            <div><img src="@/assets/banner_l1.png" alt="" /></div>
                            <img src="@/assets/banner_l2.png" alt="" />
                        </div>
                    </div>
                    <div class="banner_l_img">
                        <img src="../../../../public/Banner-left.jpg" alt="" />
                    </div>
                </div>
                <div class="banner_r">
                    <div class="wrapper">
                        <swiper ref="mySwiper" :options="swiperOptions" class="swiper-no-swiping">
                            <swiper-slide v-for="(item, index) in bannerImgs" :key="index">
                                <img :src="item" alt="" />
                            </swiper-slide>
                            <div class="swiper-button-prev"></div>
                            <div class="swiper-button-next"></div>
                        </swiper>
                    </div>
                    <div class="text-box">
                        <p>迪拜游艇租赁 | 迪拜游艇预订 | 迪拜游艇租赁</p>
                        <p>以最优惠的价格租用游艇或小船进行巡游、钓鱼和水上运动。</p>
                    </div>
                </div>
            </div>
            <div class="yachts_filter">
                <div class="yachts_filter_title">{{ $t('yacht_filter') }}</div>
                <el-form class="yachts_filter_main" ref="dataForm" :model="list">
                    <div class="select_date">
                        <p>{{ $t('select_date') }}</p>
                        <div>
                            <el-date-picker
                                v-model="list.select_dates"
                                prefix-icon="select_date_icon"
                                type="date"
                                :placeholder="`${dayjs(tomorrow).format('YYYY 年 MM 月 DD日')} ${
                                    weekCh[dayjs(tomorrow).format('d')]
                                }`"
                                :format="`yyyy 年 MM 月 dd 日 [${weekCh[dayjs(list.select_dates).format('d')]}]`"
                                value-format="yyyy-MM-dd"
                                @change="selecDate"
                                :picker-options="pickerOptionsDate"
                                :clearable="false"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="charter_hours">
                        <p>{{ $t('charter_hours') }}</p>
                        <div>
                            <span class="charter_hours_text"><b v-text="list.charter_hours"></b>小时</span>
                            <span class="charter_hours_handle">
                                <img @click="hour_up" src="@/assets/yachts_filter_up.png" alt="" />
                                <img @click="hour_down" src="@/assets/yachts_filter_down.png" alt="" />
                            </span>
                        </div>
                    </div>
                    <div class="charter_time">
                        <p>{{ $t('charter_time') }}</p>
                        <div class="charter_time_text">
                            <div class="my-slider__tooltip" :style="styles">
                                <el-button class="my-slider__tooltip-wrapper" size="mini">
                                    {{ values }}
                                </el-button>
                            </div>
                            <div class="charter_time_slider">
                                <el-slider
                                    v-model="list.charter_time"
                                    show-stops
                                    :marks="marks"
                                    :min="6"
                                    :max="23"
                                    :step="1"
                                    :show-tooltip="false"
                                    @change="timeTip"
                                ></el-slider>
                                <div class="fixedPM">12PM</div>
                            </div>
                        </div>
                    </div>
                    <div class="number_guests">
                        <p>{{ $t('number_guests') }}</p>
                        <div class="number_guests_text">
                            <div class="my-slider__tooltip" :style="style">
                                <el-button class="my-slider__tooltip-wrapper" size="mini">
                                    {{ list.number_guests }}
                                </el-button>
                            </div>
                            <el-slider
                                v-model="list.number_guests"
                                :max="45"
                                :format-tooltip="value => value"
                                :show-tooltip="false"
                                @change="numberGuests"
                            ></el-slider>
                            <p>45</p>
                        </div>
                    </div>
                    <!-- <div class="gift_code">
            <div class="gift_code_text">
              <el-input
                v-model="list.gift_code"
                :placeholder="$t('gift_code')"
              ></el-input>
              <el-button @click="apply">应用</el-button>
            </div>
          </div> -->
                </el-form>
            </div>

            <!-- 当有数据时 -->
            <div v-if="this.$store.state.home.yacthsList.length > 0" class="yachts_lists" ref="yachts_lists">
                <div class="yachts_list" v-for="(item, index) in yachts_lists" :key="index">
                    <div class="yachts_list_wrapper">
                        <div class="from_only">
                            <p>{{ $t('yachts_lists_title') }}</p>
                            <p class="price">AED {{ item.yachtsPrice }}</p>
                        </div>
                        <swiper class="swiper my-swiper" :options="swiperOption2">
                            <swiper-slide class="slide" v-for="(citem, cindex) in item.mediaArr" :key="cindex">
                                <img
                                    @click="imageShow(item.mediaArr, cindex, $event)"
                                    v-lazy="citem"
                                    v-if="cindex === 0"
                                />
                                <img
                                    @click="imageShow(item.mediaArr, cindex, $event)"
                                    :data-src="citem"
                                    class="swiper-lazy"
                                    @error="imgError"
                                    v-else
                                />
                            </swiper-slide>
                            <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                            <div class="swiper-button-prev" slot="button-prev"></div>
                            <div class="swiper-button-next" slot="button-next"></div>
                        </swiper>
                    </div>
                    <div class="yachts_list_text">
                        <div class="yachts_list_name">{{ item.productName }} {{ item.length }}英尺</div>
                        <div class="yachts_list_book" @click="book(item)">
                            <p class="chineseBook">{{ $t('yachts_lists_instantly') }}{{ $t('yachts_lists_book') }}</p>
                        </div>
                        <div class="yachts_list_address">
                            <p>{{ $t('yachts_lists_address') }}</p>
                            <span>{{ item.berth }}</span>
                        </div>
                        <div class="yachts_list_capacity">
                            <p>{{ $t('yachts_lists_capacity') }}</p>
                            <span>最多 {{ item.maxPassenger }} 人</span>
                        </div>
                        <div class="yachts_list_crew">
                            <p>{{ $t('yachts_lists_crew') }}</p>
                            <span>{{ item.crewNum }}+{{ item.captainNum }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 当游艇列表没有数据时 -->
            <Empty :emptyImage="require('@/assets/yacht_nodata.svg')" v-else></Empty>

            <div class="content">
                <div class="yachts_charter">
                    <p>{{ $t('yachts_charter') }}</p>
                    <div class="yachts_charter_detail">
                        <div>
                            <span>
                                <router-link :to="`/${$i18n.locale}/waterSports`">{{
                                    $t('yachts_charter_btn')
                                }}</router-link>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="yachts_title">{{ $t('map_title') }}</div>
                <div class="yachts_map">
                    <div class="yachts_map_wrapper">
                        <div>
                            <video :src="map_imgss" :poster="map_cover" :controls="false" autoplay loop muted></video>
                        </div>
                        <p class="yachts_map_buttons">
                            <a
                                :class="active == index ? 'active' : ''"
                                v-for="(item, index) in map_buttons"
                                :key="index"
                                @click="clickBtn(index)"
                                >{{ item }}</a
                            >
                        </p>
                        <div class="yachts_map_position">
                            <img src="@/assets/ico_dw.png" alt="" />{{ $t('map_position') }}
                        </div>
                        <div class="yachts_map_positions"></div>
                    </div>
                </div>
                <p class="yachts_map_sel">
                    <a
                        :class="active == index ? 'active' : ''"
                        v-for="(item, index) in map_address"
                        :key="index"
                        @click="clickBtn(index)"
                        >{{ item }}</a
                    >
                </p>
            </div>
            <div class="content">
                <div class="yachts_title">{{ $t('walker_title') }}</div>
                <div class="yachts_experience">
                    <video ref="walk" src="@/assets/video/video_home.mp4" autoplay loop :controls="false"></video>
                    <img v-if="walk_img" src="@/assets/yachts_experience.png" class="walk_video" alt="" />
                </div>
            </div>
        </div>
        <el-dialog
            class="book_dialog"
            :visible.sync="yachts_book"
            :lock-scroll="false"
            :append-to-body="true"
            v-if="yachts_book"
        >
            <book :books="books" @proceed_sub="proceed_sub" />
        </el-dialog>
        <PayType />
        <el-image-viewer v-if="showImage" :url-list="urlList" :initialIndex="imgIndex" :on-close="closeImage" />
    </div>
</template>

<script>
import mixin from '@/mixin/Home'
export default {
    mixins: [mixin],
}
</script>
<style lang="scss" src="@/styles/home.scss" scoped></style>
<style lang="scss" scoped>
.banner_l_main p {
    font-size: 15px;
}
.charter_time_text {
    .my-slider__tooltip {
        text-align: left;
        padding-top: 6px;
        box-sizing: border-box;

        .my-slider__tooltip-wrapper {
            background: url(@/assets/slide_tolips.png) no-repeat;
            height: 22px;
            // width: 45px;
            padding: 0 4px;
            transform: translateX(-90%);
            color: #ffcc69;
            border: none;
            background-size: 45px 22px;
            line-height: 22px;
        }

        .el-button--mini,
        .el-button--mini.is-round {
            padding: 0;
            margin-bottom: 6px;
        }
    }
}

.number_guests_text {
    .my-slider__tooltip {
        text-align: left;
        padding-top: 8px;
        box-sizing: border-box;

        .my-slider__tooltip-wrapper {
            background: url(@/assets/slide_tolip.png) no-repeat;
            height: 22px;
            width: 19px;
            transform: translateX(-90%);
            color: #ffcc69;
            border: none;
        }

        .el-button--mini,
        .el-button--mini.is-round {
            padding: 0;
            margin-bottom: 4px;
        }
    }
}

::v-deep.swiper-pagination {
    right: 0;
    left: 0;
    bottom: 6px;
    ::v-deep .swiper-pagination-bullet {
        width: 15px;
        height: 4px;
        border-radius: 4px;
        border: 1px solid #ffffff7a;
        margin: 0 2px;
        background-color: #eee;
    }
    ::v-deep .swiper-pagination-bullet-active {
        background-color: #fff;
    }
}
::v-deep.swiper-no-swiping {
    .swiper-button-prev:after,
    .swiper-button-next:after {
        content: '' !important;
    }
}
.charter_time_slider {
    position: relative;
    .fixedPM {
        position: absolute;
        bottom: -19px;
        right: -2px;
        font-size: 10px;
        color: #d9b061;
    }
}
::v-deep .charter_time_text .el-slider__runway {
    margin-right: 10px;
    width: 330px;
}
.banner_l_img {
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.banner_r {
    position: relative;
    .text-box {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 70px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        z-index: 1;
        background-color: rgba(2, 11, 59, 0.35);
        color: #fff;
        line-height: 24px;
        font-family: Lato Regular;
        padding-left: 20px;
        box-sizing: border-box;
        font-size: 18px;
    }

    .swiper-button-prev {
        background-image: url(@/assets/icon_left.png);
        background-size: cover;
        width: 40px;
        height: 80px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    .swiper-button-next {
        background-image: url(@/assets/icon_right.png);
        background-size: cover;
        width: 40px;
        height: 80px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
}
</style>
